// Rotas e produtos da Central de Treinamento (PO1-3505, épico PO1-3504).
//
// Este arquivo NÃO importa routes/products.js de propósito (mesmo motivo de
// views/Alertas/alertasUtils.js): products.js puxa todas as telas do Hub, e o
// ícone de ajuda do cabeçalho e os testes dele não precisam disso. O sentido é
// o contrário: products.js importa daqui.
//
// Sem `?.`/`??`: o build roda em CRA 3.4 / Node 12.

// Slug do path da Central por produto (/app/<slug>/treinamento).
export const TREINAMENTO_SLUG_POR_PRODUTO = {
  FLOW: "flow",
  GOBID: "gobid",
  TRACKFY: "trackfy",
  AUTOPILOT: "autopilot",
  MEUFRETE: "meufrete",
  EVERLOG_ADMIN: "everlog",
};

// Produtos que um tutorial pode ter no cadastro (campo `produtos`). O Everlog
// Admin não entra: no Admin a Central mostra todos os tutoriais.
export const PRODUTOS_TUTORIAL = [
  { codigo: "FLOW", rotulo: "Flow" },
  { codigo: "GOBID", rotulo: "GoBid" },
  { codigo: "TRACKFY", rotulo: "Trackfy" },
  { codigo: "AUTOPILOT", rotulo: "Autopilot" },
  { codigo: "MEUFRETE", rotulo: "MeuFrete" },
];

export const PRODUTO_ROTULO = PRODUTOS_TUTORIAL.reduce((acc, p) => {
  acc[p.codigo] = p.rotulo;
  return acc;
}, { EVERLOG_ADMIN: "Everlog Admin" });

// Caminho completo da Central do produto; com `codigo`, já abre o vídeo.
export function rotaCentral(produto, codigo) {
  const slug = TREINAMENTO_SLUG_POR_PRODUTO[produto] || "flow";
  const base = `/app/${slug}/treinamento`;
  return codigo ? `${base}?tutorial=${encodeURIComponent(codigo)}` : base;
}

// 165 → "2:45"; 3725 → "1:02:05". Sem toLocaleString (Node 12 small-icu).
export function formatarDuracao(segundos) {
  const n = Number(segundos);
  if (!Number.isFinite(n) || n <= 0) return "";
  const total = Math.round(n);
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  const dois = (v) => (v < 10 ? `0${v}` : String(v));
  return h > 0 ? `${h}:${dois(m)}:${dois(s)}` : `${m}:${dois(s)}`;
}

export function miniaturaYoutube(youtubeId) {
  return youtubeId ? `https://i.ytimg.com/vi/${youtubeId}/mqdefault.jpg` : null;
}

// Player sem cookie de rastreio, no segundo pedido e sem vídeos relacionados.
export function embedYoutube(youtubeId, inicioSegundos) {
  const inicio = Math.max(0, Math.floor(Number(inicioSegundos) || 0));
  return `https://www.youtube-nocookie.com/embed/${youtubeId}?start=${inicio}&rel=0`;
}

export function linkYoutube(youtubeId, inicioSegundos) {
  const inicio = Math.max(0, Math.floor(Number(inicioSegundos) || 0));
  return `https://youtu.be/${youtubeId}${inicio > 0 ? `?t=${inicio}` : ""}`;
}
